<template>
  <div v-if="client">
    <!-- registration settings -->
    <p class="title is-5">Registration settings</p>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Registration types</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div v-for="([type, { label }], index) in Object.entries(registrationTypes)"
               :key="index"
               class="switch-item">
            <input :id="type"
                   type="checkbox"
                   :name="type"
                   class="switch"
                   v-model="registrationTypes[type].allowed">
            <label :for="type">{{label}}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Default registration type</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <div class="select">
              <select v-model="client.settings.registrationSettings.defaultRegistrationType">
                <option v-for="([type, {label}], index) in allowedRegistrationTypes"
                        :key="index"
                        :value="type">{{label}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Create default balance during registration</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <label class="checkbox">
              <input v-model="client.settings.registrationSettings.createDefaultBalance" type="checkbox" />
            </label>
          </p>
        </div>
      </div>
    </div>

    <div class="field-body">
      <div class="field is-grouped">
        <div class="control">
          <button @click="save"
                  class="button is-primary">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import state from '../../../../state'
  import utils from '../../../../utils'
  import clientService from '../../../../services/client.service'

  export default {
	  name: 'client-settings-registration',
	  data() {
		  return {
			  client: {
				  settings: {
            registrationSettings: {
              registrationTypes: [],
              defaultRegistrationType: null,
              createDefaultBalance: false,
              defaultBalanceBranch: null,
              defaultBalanceFallbackCurrency: null
            }
				  },
			  },
			  registrationTypes: {
				  login: { allowed: false, label: 'Fast (login/password)' },
				  phone: { allowed: false, label: 'By phone' },
				  email: { allowed: false, label: 'By email' },
			  },
		  }
	  },
	  computed: {
		  clientId() {
			  return Number(this.$route.params.clientId)
		  },
		  allowedRegistrationTypes() {
			  return Object.entries(this.registrationTypes).filter(([_, { allowed }]) => !!allowed)
		  }
	  },
	  watch: {
		  clientId() {
			  this.loadClient()
		  }
	  },
	  async mounted() {
		  await clientService.ensure()
		  this.loadClient()
	  },
	  methods: {
		  loadClient() {
			  this.client = utils.clone(state.clients.getClient(this.clientId));
			  this.initRegistrationTypes();
			  this.protectDefaultRegistrationType();
		  },
		  initRegistrationTypes() {
        if (!this.client.settings.registrationSettings.registrationTypes) return
        this.client.settings.registrationSettings.registrationTypes.forEach(type => {
				  this.registrationTypes[type].allowed = true
			  })
		  },
		  protectDefaultRegistrationType() {
        if (!this.allowedRegistrationTypes.includes(this.client.settings.registrationSettings.defaultRegistrationType))
          this.client.settings.registrationSettings.defaultRegistrationType = (this.allowedRegistrationTypes[0] || [])[0];
		  },
		  async save() {
        this.client.settings.registrationSettings.registrationTypes = this.allowedRegistrationTypes.map(([type, _]) => type)			
			  this.protectDefaultRegistrationType()
			  await clientService.save(this.client)
		  },
	  },
  }
</script>

<style scoped>
.switch-item {
	margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/registration.vue